export const isValidMobileNumber = number => {
  // Remove any whitespace
  let phoneNumber = number.replace(/\s/g, '');

  // Check if the phone number contains only numeric values
  if (!/^\d+$/.test(phoneNumber)) {
    return {
      success: false,
      error: 'Please enter a valid UK mobile number',
    };
  }

  /*
   * Check if the phone number is either:
   * - 11 characters long with a leading '0'
   * - or 10 characters long excluding the leading '0'
   */
  if (
    (phoneNumber.length === 11 && phoneNumber.startsWith('0')) ||
    (phoneNumber.length === 10 && !phoneNumber.startsWith('0'))
  ) {
    // Check if the phone number starts with '7' (excluding the leading '0')
    if (phoneNumber.length === 11) {
      phoneNumber = phoneNumber.substring(1);
    }
    if (phoneNumber.startsWith('7')) {
      return {
        success: true,
        error: '',
      };
    }
    return {
      success: false,
      error: 'Please enter a valid UK mobile number',
    };
  }

  return {
    success: false,
    error: 'Please enter a valid UK mobile number',
  };
};
